import { useDependency } from '@nine7soft/react-di';
import { useContext, useEffect, useState } from 'react';
import { TicketPickerModule } from '../../../modules/TicketPickerModule';
import { TransportTicketPickerStore } from '../../../store/TransportTicketPickerContext';
import { Types } from '../../../store/transportTicketPickerReducer';

export const useCardSupport = () => {
    const apiClient = useDependency('apiClient');
    const { dispatch } = useContext(TransportTicketPickerStore);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        async function fetch() {
            const ticketPickerModule = new TicketPickerModule(apiClient);
            const cardSupportList = await ticketPickerModule.getCardSupportList();

            dispatch({ type: Types.UpdateCardSupport, payload: { cardSupportList: cardSupportList } });
        }
        setIsLoading(true);
        fetch();
        setIsLoading(false);
    }, []);

    return {
        isLoading
    }
};
